import React from 'react'

const PressInput = () => {
  return (
    <div>PressInput</div>
  )
}

export default PressInput